// auth
export const ACCESS_TOKEN = 'access_token'
export const REFRESH_TOKEN = 'refresh_token'
export const EXPIRES_IN = 'expires_in'

// API
// various API-related export constants
export const API_VERSION_NO = 5 // supply API version number only, without leading 'v'
// export const API_BASEURL = 'https://euprodb.com'
export const API_BASEURL = 'https://risis.opalstacked.com'
export const API_METADATA = 'metadata'
export const API_PROFILES = 'profiles'

// With API v5 we have nested categories in 'profiles'
export const API_PROFILES_GENERAL = 'general'
export const API_PROFILES_PUBLIC_ORG = 'public_org'
export const API_PROFILES_SIP = 'sip'
export const API_PROFILES_FIRMS = 'firms'

// string to use in place of unavailable/null values
export const UNAVAIL = 'N/A'
export const UNAVAIL_COLOUR = 'darkgrey'

// DIMENSIONS
// dimensions: different types of data which can be visualised / queried through the API
export const COUNTRY_DIMENSION = {name: 'Country', dimensionType: 'location', dimensionName: 'country'}
export const REGION_DIMENSION = {name: 'Region', dimensionType: 'location', dimensionName: 'region'}
export const CLASS_DIMENSION = {name: 'Class', dimensionType: 'topic', dimensionName: 'topic'}
export const SUBCLASS_DIMENSION = {name: 'Subclass', dimensionType: 'topic', dimensionName: 'topic'}
// all dimensions collected into one array
export const DIMENSIONS = [
  COUNTRY_DIMENSION,
  REGION_DIMENSION,
  CLASS_DIMENSION,
  SUBCLASS_DIMENSION
]
// dimensions are sub divided into two groups (dimensionType)
export const DIMENSION_GROUPS = [
  {header: 'Geography', dimensionType: 'location'},
  {header: 'Topics', dimensionType: 'topic'}
]

// indicator types or "knowledge types"
export const KNOWLEDGE_TYPES = [
  {
    id: 'pub',
    label: 'publications',
    description: null,
    default: true
  },
  {
    id: 'pat',
    label: 'patents',
    description: null,
    default: false
  },
  {
    id: 'proj',
    label: 'projects',
    description: null,
    default: false
  },
  {
    id: 'com',
    label: 'composite indicators',
    description: null,
    default: false
  },
  {
    id: 'norm',
    label: 'normalisation',
    description: null,
    default: false
  },
  {
    id: 'net',
    label: 'network',
    description: null,
    default: false
  },
  {
    id: 'eter',
    label: 'Higher Education',
    description: null,
    default: false
  },
  {
    id: 'firms',
    label: 'Startups / fast growing firms',
    description: null,
    default: false
  },
  {
    id: 'tm',
    label: 'trademarks',
    description: null,
    default: false
  }
]

// topics are sub divided into two groups
export const ROOT_TOPICS = [
  {code: '0A', text: 'Key Enabling Technologies', selected: true},
  {code: '0B', text: 'Sustainable Development Goals', selected: true}
]

// MISC
// various display values and default values
export const AGGREGATE_COMPLEMENTS = {
  value: 'all',
  text: 'aggregation (all)'
}
export const EACH_SELECTED_COMPLEMENT = {
  value: 'each',
  text: 'each (selected)'
}
export const NO_NORM = {
  id: 'non',
  value: 'none',
  label: 'not normalised',
  default: true
}
export const NORMALIZATION_CATEGORIES = [
  {
    id: 'non',
    value: 'none',
    label: 'not normalised',
    default: true
  },
  {
    id: 'pop',
    value: 'population',
    label: 'normalised by population',
    default: false
  }
]
export const PROFILE_INDICATORS = [
  {
    indicator_id: 'num_pub',
    value_key: 'total_publications',
    rank_key: 'rank_publications',
    public_orgs_endpoint: API_PROFILES_PUBLIC_ORG + '/' + 'pub',
    firms_endpoint: API_PROFILES_FIRMS + '/' + 'pub',
    default: true
  },
  {
    indicator_id: 'num_pat_app',
    value_key: 'total_patents',
    rank_key: 'rank_patents',
    public_orgs_endpoint: API_PROFILES_PUBLIC_ORG + '/' + 'pat',
    firms_endpoint: API_PROFILES_FIRMS + '/' + 'pat',
    default: false
  },
  {
    indicator_id: 'num_eufp_partcipat',
    value_key: 'total_projects',
    rank_key: 'rank_projects',
    public_orgs_endpoint: API_PROFILES_PUBLIC_ORG + '/' + 'proj',
    firms_endpoint: API_PROFILES_FIRMS + '/' + 'proj',
    default: false
  }
]

export default {
  ACCESS_TOKEN: ACCESS_TOKEN,
  REFRESH_TOKEN: REFRESH_TOKEN,
  EXPIRES_IN: EXPIRES_IN,
  UNAVAIL: UNAVAIL,
  UNAVAIL_COLOUR: UNAVAIL_COLOUR,
  COUNTRY_DIMENSION: COUNTRY_DIMENSION,
  REGION_DIMENSION: REGION_DIMENSION,
  CLASS_DIMENSION: CLASS_DIMENSION,
  SUBCLASS_DIMENSION: SUBCLASS_DIMENSION,
  DIMENSIONS: DIMENSIONS,
  DEFAULT_DIMENSION: COUNTRY_DIMENSION,
  DEFAULT_COMPLEMENT: CLASS_DIMENSION,
  KNOWLEDGE_TYPES: KNOWLEDGE_TYPES,
  DIMENSION_GROUPS: DIMENSION_GROUPS,
  ROOT_TOPICS: ROOT_TOPICS,
  API_BASEURL: API_BASEURL,
  API_METADATA: API_METADATA,
  API_PROFILES: API_PROFILES,
  API_PROFILES_GENERAL: API_PROFILES_GENERAL,
  API_PROFILES_PUBLIC_ORG: API_PROFILES_PUBLIC_ORG,
  API_PROFILES_SIP: API_PROFILES_SIP,
  API_PROFILES_FIRMS: API_PROFILES_FIRMS,
  API_VERSION_NO: API_VERSION_NO,
  NO_NORM: NO_NORM,
  NORMALIZATION_CATEGORIES: NORMALIZATION_CATEGORIES,
  AGGREGATE_COMPLEMENTS: AGGREGATE_COMPLEMENTS,
  EACH_SELECTED_COMPLEMENT: EACH_SELECTED_COMPLEMENT,
  PROFILE_INDICATORS: PROFILE_INDICATORS,
  TOPO_JSON: null // will be set in main.js
}



// WEBPACK FOOTER //
// ./src/constants.js